/** @file Directions panel registration: direction set, per-direction modes, mirror asymmetry and fixes. */
import { rigPanel } from '../rigKit/rigPanel';
import { DirectionsView } from './DirectionsView';

/** Rig panel over direction.setCount / setLayout4 / setMode / setFix / syncIso. */
export const panel = rigPanel('directions', 'panels.directions.title', DirectionsView);
